import {AccordionData} from "../../interfaces/AccordionData";
import AccordionWrapper from "./AccordionWrapper";
import AccordionDetailsInput from "./AccordionDetailsInput";
import React from "react";

export function InputAccordion(props: {
    title: string,
    data: AccordionData[],
    data1: (value: (((prevState: AccordionData[]) => AccordionData[]) | AccordionData[])) => void
}) {
    return <AccordionWrapper title={props.title}><AccordionDetailsInput data={props.data}
                                                                        setData={props.data1}/></AccordionWrapper>;
}